import { put, take } from 'redux-saga/effects';

export function* putAPI(apiAction) {
    yield put(apiAction);

    const response = yield take([
        `${apiAction.type} [success]`,
        `${apiAction.type} [fail]`
    ]);

    if (response.type === `${apiAction.type} [success]`) return response;

    throw new Error(response.payload);
}
